export default __webpack_public_path__ + "static/media/30.82f9d00c.jpg";